import {externalBaseApi, extractData} from "../../api/axiosConfig";


export const getAllStakeholderList = () =>
    externalBaseApi
        .get("/stakeholderList")
        .then(extractData);

export const getStakeholderListGridData = productId =>
    externalBaseApi
        .get("/stakeholderList/gridData", {
            params: {
                my_product_id: productId
            }
        })
        .then(extractData);

export const getStakeholderListObligationData = cdpvId =>
    externalBaseApi
        .get("/stakeholderList/obligationData", {
            params: {
                my_cdpv_id: cdpvId
            }
        })
        .then(extractData);

export const uploadStakeholderList = stakeholderList =>
    externalBaseApi
        .post("/stakeholderList/upload", stakeholderList)
        .then(extractData);

export const getFileIds = () =>
    externalBaseApi
        .get("/stakeholderList/fileId")
        .then(extractData);

export const getGuilds = () =>
    externalBaseApi
        .get("/stakeholderList/guild")
        .then(extractData);

export const getJobCodes = () =>
    externalBaseApi
        .get("/stakeholderList/jobCode")
        .then(extractData);

export const getContractLengths = () =>
    externalBaseApi
        .get("/stakeholderList/contractLength")
        .then(extractData);

export const processStakeholderList = fileId =>
    externalBaseApi
        .get("/stakeholderList/process", {
            params: {
                stakeholder_list_file_id: fileId
            }
        })
        .then(extractData);

export const stakeholderListSearch = request =>
    externalBaseApi
        .post("/stakeholderList/stakeholderListSearch", request)
        .then(extractData);

export const addStakeholderList = data =>
    externalBaseApi
        .post("/stakeholderList", data)
        .then(extractData);

export const editStakeholderList = (stakeholderListId, data) =>
    externalBaseApi
        .put(`/stakeholderList/${stakeholderListId}`, data)
        .then(extractData);

export const deleteStakeholderList = stakeholderListId =>
    externalBaseApi
        .delete(`/stakeholderList/${stakeholderListId}`)
        .then(extractData);

// import fetch from 'unfetch';
// import axios from "axios";
//
// const BASE_URL = import.meta.env.VITE_BACKEND_URL;
//
//
// export const getAllStakeholderList = () =>
//     axios.get(`${BASE_URL}/ExternalData/api/contramatic/stakeholderList`, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
// .catch(function (error) {
//     if (error.response) {
//         // The request was made and the server responded with a status code
//         // that falls out of the range of 2xx
//         console.log(error.response.data);
//         console.log(error.response.status);
//         console.log(error.response.headers);
//     } else if (error.request) {
//         // The request was made but no response was received
//         // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//         // http.ClientRequest in node.js
//         console.log(error.request);
//     } else {
//         // Something happened in setting up the request that triggered an Error
//         console.log('Error', error.message);
//     }
//     console.log(error.config);
// });
//
//
// export const getStakeholderListGridData = (my_product_id) =>
//     axios.get(`${BASE_URL}/ExternalData/api/contramatic/stakeholderList/gridData`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {my_product_id: my_product_id}
//         })
//         // export const executeExpression = (id) =>
//         //     axios.get(`${BASE_URL}/api/contramatic/contractDataPoint/expression/${id}`)
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const getStakeholderListObligationData = (my_cdpv_id) =>
//     axios.get(`${BASE_URL}/ExternalData/api/contramatic/stakeholderList/obligationData`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {my_cdpv_id: my_cdpv_id}
//         })
//         // export const executeExpression = (id) =>
//         //     axios.get(`${BASE_URL}/api/contramatic/contractDataPoint/expression/${id}`)
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
// export   const uploadStakeholderList = (stakeholderList) =>
//     axios.post(`${BASE_URL}/ExternalData/api/contramatic/stakeholderList/upload`,stakeholderList, {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             }
//         })
//         .then(function (response) {
//             console.log(response);
//         })
//         .catch(function (error) {
//             if (error.response) {
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 console.log(error.request);
//             } else {
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const getFileIds = () =>
//     axios.get(`${BASE_URL}/ExternalData/api/contramatic/stakeholderList/fileId`, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const getGuilds = () =>
//     axios.get(`${BASE_URL}/ExternalData/api/contramatic/stakeholderList/guild`, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
// export const getJobCodes = () =>
//     axios.get(`${BASE_URL}/ExternalData/api/contramatic/stakeholderList/jobCode`, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const getContractLengths = () =>
//     axios.get(`${BASE_URL}/ExternalData/api/contramatic/stakeholderList/contractLength`, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const processStakeholderList = (fileId) =>
//     axios.get(`${BASE_URL}/ExternalData/api/contramatic/stakeholderList/process`,
//
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {stakeholder_list_file_id: fileId}
//         })
//         // export const executeExpression = (id) =>
//         //     axios.get(`${BASE_URL}/api/contramatic/contractDataPoint/expression/${id}`)
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const stakeholderListSearch = (request) =>
//
//     axios.post(
//         `${BASE_URL}/ExternalData/api/contramatic/stakeholderList/stakeholderListSearch`,
//         request,
//         // CONFIG
//         {
//             headers: {
//                 Authorization:
//                     'Bearer ' + localStorage.getItem('token'),
//                 'Content-Type': 'application/json'
//             }
//         }
//     )
//
//         .catch(function (error) {
//
//             if (error.response) {
//
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//
//             } else if (error.request) {
//
//                 console.log(error.request);
//
//             } else {
//
//                 console.log('Error', error.message);
//
//             }
//
//             console.log(error.config);
//
//         });
//
//
//
//
// export   const addStakeholderList = abcd =>
//     axios.post(`${BASE_URL}/ExternalData/api/contramatic/stakeholderList`, abcd, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         .then(function (response) {
//             console.log(response);
//         })
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
// export const editStakeholderList = (selectorStakeholderListId, data) =>
//     axios.put(`${BASE_URL}/ExternalData/api/contramatic/stakeholderList/${selectorStakeholderListId}`, data, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         .then(function (response) {
//             console.log(response);
//         })
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// //https://www.javatpoint.com/react-axios-delete-request-example except that it shows the wrong kinds of quotes - not backquotes
// export const deleteStakeholderList = selectorStakeholderListId =>
//     axios.delete(`${BASE_URL}/ExternalData/api/contramatic/stakeholderList/${selectorStakeholderListId}`, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         //https://axios-http.com/docs/handling_errors
//         .then(function (response) {
//             console.log(response);
//         })
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
